import type { AuthErrorLike } from "./types";

export const getAuthErrorLike = (error: unknown): AuthErrorLike => {
	if (typeof error === "object" && error !== null) {
		return error as AuthErrorLike;
	}
	return {};
};

export const isBlockingTimeoutError = ({ code, message }: AuthErrorLike) => {
	const normalized = (message || "").toLowerCase();
	const hasTimeoutMessage =
		normalized.includes("deadline exceeded") ||
		normalized.includes("cloud function deadline exceeded");
	return code === "auth/internal-error" && hasTimeoutMessage;
};

export const isRetryableBlockingError = (
	error: AuthErrorLike,
	blockingFunctionErrors: string[]
) => {
	const { code, message } = error;
	if (code && blockingFunctionErrors.includes(code)) return true;
	const normalized = (message || "").toLowerCase();
	return (
		normalized.includes("deadline exceeded") ||
		normalized.includes("the service is currently unavailable")
	);
};
